import { ConfigurableColumns } from '@/components/ConfigurableColumns';
import { CopiableIdDataGridField } from '@/components/CopiableIdField';
import { GenericDateFunctionField } from '@/components/GenericDateFunctionField';
import { Chip } from '@mui/material';
import { FunctionField, ReferenceField } from 'react-admin';

export const columns: ConfigurableColumns[] = [
  {
    label: 'Event Id',
    source: 'id',
    GridComponent: CopiableIdDataGridField,
    omit: true,
  },
  {
    label: 'Event Time',
    source: 'when',
    sortable: true,
    GridComponent: GenericDateFunctionField,
    exportFn: record => record.when?.toString(),
  },
  {
    label: 'Event Name',
    source: 'eventName',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) => <Chip label={record.eventName} />,
    },
  },
  {
    label: 'Context',
    source: 'params.pageContext',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) => (
        <Chip label={record.params.pageContext} />
      ),
    },
    exportFn: record => record.params.pageContext,
  },
  {
    label: 'Device Id',
    source: 'uniqueDeviceId',
    GridComponent: CopiableIdDataGridField,
    gridComponentProps: {
      // targetNavigationResource: "appTrackerDevices",
      // referenceField: "uniqueDeviceId",
      filter: ['uniqueDeviceId', 'uniqueDeviceId'],
    },
  },
  {
    label: 'App Bundle Id',
    source: 'params.appId',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) => <Chip label={record.params.appId} />,
    },
    exportFn: record => record.params.appId,
  },
  {
    label: 'App Version',
    source: 'params.appVersion',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) => (
        <Chip label={record.params.appVersion} />
      ),
    },
    exportFn: record => record.params.appVersion,
  },
  {
    label: 'User Id',
    source: 'userId',
    GridComponent: CopiableIdDataGridField,
    gridComponentProps: {
      targetNavigationResource: 'therapists',
      referenceField: '_id',
      filter: ['userId', 'userId'],
    },
    exportFn: record => record.userId,
  },
  {
    label: 'Therapist',
    source: 'userId',
    GridComponent: FunctionField,
    exportFn: () => null,
    gridComponentProps: {
      render: (record: any) => (
        <ReferenceField
          reference="therapists"
          record={{ id: record.userId }}
          source="id"
        >
          <FunctionField
            render={(record: any) =>
              `${record.title ? `${record.title} ` : ''}${record.firstName} ${
                record.lastName
              }`
            }
          />
        </ReferenceField>
      ),
    },
  },
];
